/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*******************************************!*\
  !*** ./resources/js/predictive-search.js ***!
  \*******************************************/
// API call predictive search
console.log("Predictive search");
$(document).ready(function () {
  $("body").on("keyup", ".search__input", function () {
    console.log("Predictive search");
    $(".search-results").html('');
    var query = $(this).val();
    console.log("Query", query, query.length);

    if (query.length > 2) {
      $.ajax({
        type: "get",
        url: "/search?q=".concat(query, "&options%5Bprefix%5D=last&section_id=main-search"),
        data: {},
        success: function success(response) {
          console.log("RESPONSE: ", response);
          $(".search-results").html('');
          $(".search-results").append("<div class=\"YAY\" >".concat(response, "</div>"));
        },
        error: function error(XMLHttpRequest, textStatus, errorThrown) {
          alert("Status: " + textStatus);
          alert("Error: " + errorThrown);
        }
      });
    }
  });
});
/******/ })()
;